import React from 'react'

import WidgetContainer from '@SonarCX/components/atoms/WidgetContainer'
import UpcomingReminders from './BodyWidgets/UpcomingReminders'

import useStyles from './styles'

const RemindersTab: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <WidgetContainer
        variant='header'
        className={classes.headerRoot}
      ></WidgetContainer>

      <WidgetContainer variant='body' className={classes.bodyRoot}>
        <UpcomingReminders fullWidth />

        <UpcomingReminders skipDays={1} upcomingDays={7} />

        <UpcomingReminders skipDays={8} upcomingDays={30} />
      </WidgetContainer>
    </>
  )
}

export default RemindersTab
